// extracted by mini-css-extract-plugin
export default {"fab":"WhatsAppFab_fab__iE3tn","icon":"WhatsAppFab_icon__lyYHH"};